import React from 'react';
import { useHistory } from 'react-router-dom';
import storyData from '../../assets/stories/Story-3.json';
import './Story3.css';

const Story3: React.FC = () => {
  const history = useHistory();

  return (
    <div className="story3-container">
      <button className="close-button" onClick={() => history.push('/')}>X</button>
      <div className="parchment">
        <h2>{storyData.title}</h2>
        <p>{storyData.text}</p>
      </div>
    </div>
  );
};

export default Story3;